import React, { PureComponent } from 'react'
import { Button, Form, Message, Modal } from 'semantic-ui-react'
import { register, notAuthenticated } from '../../services/self'
import { confirmMarketplaceSubscription } from '../../services/api-catalog'
import 'react-notifications/lib/notifications.css';
import { NotificationManager} from 'react-notifications';




 export default class Register extends PureComponent {
  state = {
    isSubmitting: false,
    signedIn: false,
    errorMessage: '',
    isOpen: false,
    tryAgain: false,
    submitted: false,
    clearInput: false,
    valueAttr: '',
    valueAttr2: '',
    username: '',
    email: '',
    password: ''
  }



  createNotification = (type) => {
    return () => {
      switch (type) {
        case 'info':
          NotificationManager.info('Info message');
          break;
        case 'success':
          NotificationManager.success('Success message', 'Title here');
          break;
        case 'warning':
          NotificationManager.warning('Warning message', 'Close after 3000ms', 3000);
          break;
        case 'error':
          NotificationManager.error('Error message', 'Click me!', 5000, () => {
            alert('callback');
          });
          break;
          default : console.log();

      }
    };
  };

  open = () => this.setState({ isSubmitting: false, errorMessage: '', isOpen: true })
  close = () => this.setState({ isOpen: false })
  handleRegister = (event, serializedForm) => this._handleRegister(event, serializedForm)

  _handleRegister(event, serializedForm) {
    event.preventDefault()
    this.setState({isSubmitting: true, tryAgain: false})
    console.log("about to register")

    const canRegister = serializedForm.password === serializedForm.confirmPassword;


    if (canRegister){

    //register(serializedForm.username, serializedForm.email, serializedForm.password)
    register(this.state.username, this.state.email, this.state.password)
    .then(() => {


      console.log("closing form")
      this.setState({signedIn: false, isSubmitting: false, submitted: true, errorMessage: ''})

      const {usagePlanId, token} = this.props

      if (usagePlanId && token) {
        return confirmMarketplaceSubscription(usagePlanId, token)
      }

    }).then(() => {
      console.log(`Setting user as not authenticated.`);
      notAuthenticated()
    }).catch((e) => {this.setState({errorMessage: e.message, isSubmitting: false, signedIn: false})
        console.log(`After error signedIn is ${this.state.signedIn}`)
        notAuthenticated()

    })

   } else {

    console.log("Passwords do not match!");
    console.log(`The value of tryAgain is BEFORE: ${this.state.tryAgain}`)
    this.setState({signedIn: false, isSubmitting: false, tryAgain: true, errorMessage: ''})
    console.log(`The value of tryAgain is AFTER: ${this.state.tryAgain}`)

    }
  }



  handleChange = (e) => {
    this.setState({valueAttr: e.target.value});

  }

  handleChange2 = (e) => {

    this.setState({valueAttr2: e.target.value});
    this.setState({ password: e.target.value});
  }

  resetState = (event, serializedForm) =>
  {
    console.log("Focus has been activated!")
    console.log('resetState!');
    this.setState({tryAgain: false});
    this.setState({valueAttr: ''});
    this.setState({valueAttr2: ''});
    this.createNotification('info');
  }




  render() {
    const { isOpen } = this.state

    const inlineStyle = {
        modal : {
          marginTop: '0px !important',
          top: '30% !important'

        }
      };


    return  (

      <Modal
        size='small'
        open={isOpen}
        onOpen={this.open}
        onClose={this.close}
        style={inlineStyle.modal}
        trigger={<a className="Signup-link" href="#">Sign Up</a>}
      >
        <Modal.Header>Sign Up</Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.handleRegister} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Form.Input label='Username' name='username' onChange={ (e) => this.setState({ username: e.target.value }) } />
            <Form.Input label='Email' name='email' onChange={ (e) => this.setState({ email: e.target.value }) }/>
            <Form.Input className={ this.state.tryAgain ? 'error' : ''} value={this.state.valueAttr} onChange={this.handleChange} ref='passwordField' placeholder='password' type='password' label={ this.state.tryAgain ? 'Passwords do not match' : 'Password'}  name='password' autoComplete='false' />
            <Form.Input className={ this.state.tryAgain ? 'error' : ''} value={this.state.valueAttr2} onChange={this.handleChange2} ref='confirmPasswordField' type='password' placeholder='confirm password' label='Confirm Password' name='confirmPassword' autoComplete='false' />
            <Message error content={this.state.errorMessage} />
            {this.state.submitted ? <Message header='Sign Up Completed' content='You have been registered, a confirmation email will be sent to the addressed specified. Please follow the link in the email to complete the registration process.' /> : '' }

            {this.state.submitted ? '' : <Message header='Sign Up Completed'> By signing up and registering with this developer.newforma.cloud and using an API, you hereby agree to our <a href="https://www.newforma.com/terms-and-conditions/">Terms and Conditions.</a> </Message> }

            <Modal.Actions style={{textAlign: 'right'}}>
            {  this.state.tryAgain ? <Button type='button' onClick={this.resetState}>Clear Passwords</Button> : ''}
              <Button type='button' onClick={this.close}>Close</Button>
              {this.state.submitted ? '' : <Button primary type='submit'>Register</Button>}

            </Modal.Actions>
          </Form>
        </Modal.Content>
      </Modal>)

      // {this.state.submitted ? <Form >
      //     <Message content='Success'/>
      //     <Button type='button' onClick={this.close}>Close</Button>
      //
      //
      // </Form> : ''}
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/Register/index.js
 **/